import { Component } from "@angular/core"
import { UserService } from "../../../services/user.service"
import { CardComponent } from "../card.component"
import { routeAnimations, routeTransition } from "../../../utils/animations"

@Component({
    selector: "app-mfr-card",
    templateUrl: "./mfr-card.component.html",
    styleUrls: ["./mfr-card.component.scss"],
    host: { "[@routeTransition]": "true", "[@routeAnimations]": "false", style: "display: block;" },
    animations: [routeTransition, routeAnimations],
    standalone: false,
})
export class MfrCardComponent extends CardComponent {
    constructor(public userService: UserService) {
        super(userService)
    }
}
